<div class="jsonLine"><ng-template #vcrKey /><span class="jsonLineSeparator">:</span><ng-template #vcrValue /></div>
